export const BUDGET_DEBTS_TABLE_ARIA_LABEL = 'Заборгованість перед бюджетом';
export const BUDGET_DEBTS_TABLE_MIN_WIDTH = 500;
export const BUDGET_DEBTS_TABLE_HEADERS = ['Вид заборгованості', 'Сума, тис. од.'] as const;
export const BUDGET_DEBTS_TABLE_COLUMN_WIDTHS = ['70%', '30%'] as const;
